<div class="datagridsidebar__header bg">
    <h2>View</h2>
    <div class="sidebar__action">
        <span (click)="onAdvanceFiltersClick($event)" class="hand advanced-filter">Applied filters ({{ cadvFilters.getFiltersLength() }})</span>
        <a class="close" (click)="cadvFilters.close()"><i class="fa-regular fa-times"></i></a>
    </div>
</div>

<div class="view-content">
    <div class="flex-row--inner">
        <div class="flex-col-sm-12">
            <div class="search-module search-module--secondary">
                <input type="text" [(ngModel)]="query" placeholder="Search" class="search-module__input">
                <i class="fa-regular fa-magnifying-glass search-module__icon"></i>
            </div>
        </div>
    </div>
    <div class="flex-row--inner">
        @for (field of fields; track findex; let findex = $index) {
            <div class="flex-col-sm-12">
                <h5 class="list-group-heading">{{ field.label }}</h5>
                <ul class="datagrid-list-group">
                    @for (field of field.fields | filter:query:'label'; track index; let index = $index) {
                        <li (click)="onFieldSelect($event, field)">
                            <a href="#">{{ field.label }}</a>
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
</div>